import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-outlined pt-3 px-3 md:pt-4 md:px-4" }
const _hoisted_2 = { class: "flex text-sm md:text-base" }
const _hoisted_3 = { class: "leading-tight pr-3" }
const _hoisted_4 = { class: "leading-tight" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = {
  key: 1,
  class: "h-44 px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-subtitle-underline" }, "お知らせ", -1)),
    (Array.isArray(_ctx.notices) && _ctx.notices.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notices, (notice) => {
              return (_openBlock(), _createElementBlock("li", {
                key: notice.id,
                class: "pb-3 md:pb-4"
              }, [
                _createVNode(_component_router_link, {
                  to: `/notice/${notice.id}`,
                  class: "text-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dayjs(notice.published_at).format('YYYY/MM/DD')), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(notice.title), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/notice",
              class: "text-link text-sm"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" すべてのお知らせを見る> ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, " お知らせはありませんでした。 "))
  ], 64))
}